import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { doctorDashboardApi } from '../../api/doctorApi';

// Async thunks
export const fetchDashboardStats = createAsyncThunk(
  'doctorDashboard/fetchStats',
  async (_, { rejectWithValue }) => {
    try {
      const response = await doctorDashboardApi.getStats();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch dashboard stats');
    }
  }
);

export const fetchDashboardTrends = createAsyncThunk(
  'doctorDashboard/fetchTrends',
  async (months = 6, { rejectWithValue }) => {
    try {
      const response = await doctorDashboardApi.getTrends(months);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch dashboard trends');
    }
  }
);

export const fetchConsultationDistribution = createAsyncThunk(
  'doctorDashboard/fetchConsultationDistribution',
  async (_, { rejectWithValue }) => {
    try {
      const response = await doctorDashboardApi.getConsultationDistribution();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch consultation distribution');
    }
  }
);

const initialState = {
  stats: {
    data: null,
    loading: false,
    error: null
  },
  trends: {
    data: [],
    loading: false,
    error: null
  },
  consultationDistribution: {
    data: [],
    loading: false,
    error: null
  }
};

const doctorDashboardSlice = createSlice({
  name: 'doctorDashboard',
  initialState,
  reducers: {
    clearDashboardData: (state) => {
      state.stats = initialState.stats;
      state.trends = initialState.trends;
      state.consultationDistribution = initialState.consultationDistribution;
    }
  },
  extraReducers: (builder) => {
    // Stats
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.stats.loading = true;
        state.stats.error = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.stats.loading = false;
        state.stats.data = action.payload;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.stats.loading = false;
        state.stats.error = action.payload;
      });
    // Trends
    builder
      .addCase(fetchDashboardTrends.pending, (state) => {
        state.trends.loading = true;
        state.trends.error = null;
      })
      .addCase(fetchDashboardTrends.fulfilled, (state, action) => {
        state.trends.loading = false;
        state.trends.data = action.payload;
      })
      .addCase(fetchDashboardTrends.rejected, (state, action) => {
        state.trends.loading = false;
        state.trends.error = action.payload;
      });
    // Consultation Distribution
    builder
      .addCase(fetchConsultationDistribution.pending, (state) => {
        state.consultationDistribution.loading = true;
        state.consultationDistribution.error = null;
      })
      .addCase(fetchConsultationDistribution.fulfilled, (state, action) => {
        state.consultationDistribution.loading = false;
        state.consultationDistribution.data = action.payload;
      })
      .addCase(fetchConsultationDistribution.rejected, (state, action) => {
        state.consultationDistribution.loading = false;
        state.consultationDistribution.error = action.payload;
      });
  }
});

export const { clearDashboardData } = doctorDashboardSlice.actions;
export default doctorDashboardSlice.reducer; 